const prefixClass = 'c-toast';
export default {
  props: {
    type: {
      type: String,
      default: 'loading'
    },
    message: {
      type: String
    },
    isShow: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      interval: 0,
      isClosed: false,
      // type: 'loading',
      styles: {
        top: '50%',
        left: '50%',
        marginLeft: ''
      }
    };
  },
  computed: {
    classes() {
      return `${prefixClass} ${prefixClass}-${this.type || 'msg'}`;
    },
    iconClass() {
      return {
        warning: 'iconfont-warning',
        success: 'iconfont-chenggong',
        fail: 'iconfont-shibai',
        error: 'iconfont-cry',
        msg: 'iconfont-warning'
      }[this.type];
    }
  },
  methods: {
    show() {
      const $content = this.$el.querySelector('.toast-content');
      this.isClosed = false;
      // this.isShow = true;
      this.$nextTick(() => {
        const width = `${-$content.clientWidth / 2}px`;
        const height = `${-$content.clientHeight / 2}px`;
        this.styles.left = '50%';
        this.styles.top = '50%';
        this.styles.marginLeft = width;
        this.styles.marginTop = height;
      });
      if (this.duration) {
        this.closeMyself();
      }
    },
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    close() {
      this.isClosed = true;
      // this.isShow = false;
      // this.$el.addEventListener('transitionend', this.destroyElement);
      this.destroyElement();
    },
    closeMyself() {
      const timer = setTimeout(() => {
        if (this.isClosed) {
          return;
        }
        this.destroyElement();
        clearTimeout(timer);
      }, this.duration);
    }
  },
  mounted() {},
  watch: {
    isShow() {}
  }
};